import { TableCell, TableRow } from '@mui/material'
import React from 'react'
// import { unitMeasureShortText } from '../../../helpers/unitMeasure/UnitMeasureHelper'
import AgreeNachButton from '../supplyBill/forms/agreeNach/AgreeNachButton'
import AgreeEconomistButton from '../supplyBill/forms/agreeEconomist/AgreeEconomistButton'
import AgreeHeaderButton from '../supplyBill/forms/agreeHeader/AgreeHeaderButton'
import DeleteBillItemButton from '../supplyBill/forms/deleteItem/DeleteBillItemButton'
import ChangePriceBillItemButton from '../supplyBill/forms/changePrice/ChangePriceBillItemButton'
import { Link } from 'react-router-dom'
import ChangeContractButton from '../supplyBill/forms/changeContract/ChangeContractButton'
import ChangeExpenseTypeButton from '../supplyBill/forms/changeExpenseType/ChangeExpenseTypeButton'
import AgreeDeputyDirectorSupplyButton from '../supplyBill/forms/agreeDeputyDirectorSupply/AgreeDeputyDirectorSupplyButton'
import { useSelector } from 'react-redux'

const SupplyBillItemsAllItem = ({ supplyBillItem }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[supplyBillItem.unitMeasure] ? unitMeasures[supplyBillItem.unitMeasure].name : '?'

    const supplyOrderId = supplyBillItem.supplyOrder ? supplyBillItem.supplyOrder.id : ''

  return (
    <TableRow>
        <TableCell align='center'>
            {
                supplyBillItem.id
            }
        </TableCell>
        <TableCell align='center'>
            <Link to={`/supply/orders/${supplyOrderId}`}>
                {supplyOrderId}
            </Link>
            {/* {
				supplyBillItem.supplyOrder ? supplyBillItem.supplyOrder.id : ''
			} */}
        </TableCell>
        <TableCell align='center'>
            <Link to={`/supply/bills/${supplyBillItem.supplyBillId}`}>
                {supplyBillItem.supplyBillId}
            </Link>
            {/* {
				supplyBillItem.supplyBillId
			} */}
        </TableCell>
        <TableCell align='center' className='wordBreakAll' sx={{minWidth: 250}}>
            {
				supplyBillItem.nameInBill ? supplyBillItem.nameInBill : supplyBillItem.name + ' (з заявки)'
			}
        </TableCell>
        <TableCell align='center'>
            <ChangeContractButton
                supplyBillItem={supplyBillItem}
            />
            {/* {
				supplyBillItem.contractNumber
			} */}
        </TableCell>
        <TableCell align='center'>
            <ChangeExpenseTypeButton
                supplyBillItem={supplyBillItem}
            />
        </TableCell>
        <TableCell align='center'>
            {
				// supplyBillItem.count + ' ' + unitMeasureShortText[supplyBillItem.unitMeasure]
				supplyBillItem.count + ' ' + unitMeasure
			}
        </TableCell>
        <TableCell align='center'>
            <ChangePriceBillItemButton
                supplyBillItem={supplyBillItem}
            />
        </TableCell>
        <TableCell align='center'>
            <div className='supplyAgrees supplyAgrees__center'>
                <AgreeNachButton
                    supplyBillItem={supplyBillItem}
                />
                <AgreeEconomistButton
                    supplyBillItem={supplyBillItem}
                />
                <AgreeDeputyDirectorSupplyButton
                    supplyBillItem={supplyBillItem}
                />
                <AgreeHeaderButton
                    supplyBillItem={supplyBillItem}
                />
            </div>
        </TableCell>
        <TableCell align="center" className='myTable__actions'>
            {/* <DeleteBillItemButton
                supplyBillItem={supplyBillItem}
            /> */}
        </TableCell>
    </TableRow>
  )
}

export default SupplyBillItemsAllItem